import { useCallback, useMemo } from 'react';

import { Button } from '@mui/material';
import { RiFileExcel2Fill } from 'react-icons/ri';

import { useListagemContext } from 'context/ListagemContext';
import { useDownloadFile } from 'hooks/useDownloadFile';
import { RequestOptionsType } from 'hooks/useRequestListagem';

interface RelatorioCreditosRoyaltiesDetalhamentoCreditosProps {
    disabled: boolean;
}

export function RelatorioCreditosRoyaltiesDetalhamentoCreditos({ disabled }: RelatorioCreditosRoyaltiesDetalhamentoCreditosProps) {
    const { filter } = useListagemContext();

    const requestOptions: RequestOptionsType = useMemo(
        () => ({
            url: '/financeiro/detalhamentocreditodebitowrapper/royalties/relatorio',
            columns: 'idDetalhamentoCreditoDebito', // somente esta aqui por ser obrigatório no endpoint
            filter,
        }),
        [filter],
    );

    const { isLoadingFile, downloadFile } = useDownloadFile({
        requestOptions,
    });

    const handleClickDownload = useCallback((): void => {
        downloadFile({
            newRequestOptions: requestOptions,
            directDownload: true,
        });
    }, [downloadFile, requestOptions]);

    return (
        <Button
            loading={isLoadingFile}
            variant="outlined"
            color="success"
            onClick={handleClickDownload}
            disabled={disabled || isLoadingFile}
            startIcon={<RiFileExcel2Fill />}
        >
            Detalhamento Créditos Lançados em Royalties
        </Button>
    );
}
